module.exports = __webpack_public_path__ + "img/t1-9.2ef6f62e.png";